export default "__VITE_ASSET__BXwLCXWk__"